import { Box, makeStyles } from "@material-ui/core";
import { useParams } from "react-router-dom";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { useAnalysisSelector } from "src/context/analysisContext";
import BaseTable from "./BaseTable";

const useStyle = makeStyles((theme) => ({
  root: {
    minWidth: "300px",
    padding: "1rem 1rem 0rem 0rem",
    [theme.breakpoints.up("md")]: {
      flexGrow: 0,
      maxWidth: "33.33333%",
      flexBasis: "33.3333%",
    },
    [theme.breakpoints.between("sm", "md")]: {
      flexGrow: 0,
      maxWidth: "50%",
      flexBasis: "50%",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },
}));

const headerConfig = {
  creditScore: [
    { title: "Rank", colSpan: 2 },
    { title: "Wallet Address", colSpan: 5 },
    { title: "Credit Score", colSpan: 5 },
  ],
  increasing: [
    { title: "Rank", colSpan: 2 },
    { title: "Wallet Address", colSpan: 5 },
    { title: "Average Increasing", colSpan: 5 },
  ],
  average: [
    { title: "Rank", colSpan: 2 },
    { title: "Wallet Address", colSpan: 5 },
    { title: "Average", colSpan: 5 },
  ],
};

export default function TopTable() {
  const cls = useStyle();
  const { holder } = useParams();
  const topData = useAnalysisSelector((state) => state.statistic[holder]?.topData);

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
      <PaperWrapper title="Top Credit Scores" className={cls.root} paperProps={{ style: { padding: 0 } }}>
        <BaseTable tableHeaderConfig={headerConfig["creditScore"]} data={topData?.topScore} />
      </PaperWrapper>
      <PaperWrapper title="Top Increasing Credit Scores" className={cls.root} paperProps={{ style: { padding: 0 } }}>
        <BaseTable tableHeaderConfig={headerConfig["increasing"]} data={topData?.topIncreasing} />
      </PaperWrapper>
      <PaperWrapper title="Top Average Credit Scores" className={cls.root} paperProps={{ style: { padding: 0 } }}>
        <BaseTable tableHeaderConfig={headerConfig["average"]} data={topData?.topAverage} />
      </PaperWrapper>
    </Box>
  );
}
